<template>
  <div class="wrapper full-parent">
    <img class="mask" src="~@/assets/images/home_pic1_mask.png" />
    <img
      alt="妈妈来了官网-100%自营月嫂-深圳月嫂公司-十大安全服务保障为您保驾护航"
      class="logo"
      width="121"
      height="75"
      src="~@/assets/images/logo.jpg"
    />
    <img
      alt="妈妈来了官网logo"
      class="logo"
      width="121"
      height="75"
      src="~@/assets/images/logo.png"
    />
    <div class="info-block flex-column align-center">
      <img
        draggable="false"
        class="title-image"
        src="https://mm2015.mamalaile.com.cn/d982aa70dd77ce2ef9f216e895d69c09.png"
      />
      <div class="description">
        自营月嫂 / 十大服务保障 / 93%母乳喂养 / 2万+妈妈推荐
      </div>
      <div class="button-block flex-row">
        <mpPopover>
          <button
            class="button primary flex-row justify-center align-center pointer"
          >
            <span class="label">选月嫂</span>
          </button>
        </mpPopover>
        <button
          class="button flex-row justify-center align-center pointer"
          @click="handleShowIntroductionVideo(true)"
        >
          <span class="label">了解我们</span>
          <img
            draggable="false"
            class="play"
            src="~@/assets/images/home_pic1_video@2x.png"
          />
        </button>
      </div>
    </div>

    <div
      v-if="showIntroductionVideo"
      class="introduction-video flex-column align-center justify-center"
      @click="handleShowIntroductionVideo(false)"
    >
    <video class="video-wrapper" autoplay controls src="https://alliance.yuesaolianmeng.com/alliancevue/gw0000a838c9b90b81e8bfc109f517a38b.mp4" @click.stop></video>
      <!-- <div id="introductionPlayer" class="video-wrapper" @click.stop></div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover },

  data() {
    return {
      showIntroductionVideo: false,
      // qiniuPlayer: <any>null,
    };
  },

  methods: {
    handleShowIntroductionVideo(visible: boolean) {
      if (visible) {
        this.showIntroductionVideo = true;
        this.$emit('showVideo', true);
        // this.$nextTick(() => {
        //   this.qiniuPlayer = new QPlayer({
        //     url: "https://alliance.yuesaolianmeng.com/alliancevue/gw0000a838c9b90b81e8bfc109f517a38b.mp4",
        //     container: document.getElementById("introductionPlayer"),
        //     autoplay: true,
        //     muted: false,
        //     isLive: false,
        //     loggerLevel: 3,
        //   });
        //   console.clear();
        // });
      } else {
        this.distoryPlayer();
      }
    },

    distoryPlayer() {
      // if (!this.qiniuPlayer) { console.clear(); return; };
      // console.log(this.qiniuPlayer);
      // this.qiniuPlayer.pause();
      // this.qiniuPlayer.destroy();
      this.$nextTick(() => {
        // this.qiniuPlayer = null;
        this.showIntroductionVideo = false;
        this.$emit('showVideo', false);
        // console.clear();
      });
    },
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  background: @color-skeleton url("~@/assets/images/home_pic1_bg@2x.jpg");
  background-size: cover;
  background-position: 50% 50%;

  .logo {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    transform: translate(-110%, -110%);
  }

  .mask {
    width: 40vw;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .info-block {
    position: absolute;
    top: 50%;
    left: 9.11vw;
    transform: translateY(-50%);

    .title-image {
      width: 26.61vw;
      height: auto;
      margin-bottom: 1.61vw;
    }

    .description {
      font-size: 1.04vw;
      color: #858585;
      line-height: 1.41vw;
      margin-bottom: 2.08vw;
    }

    .button-block {
      @hr: 2.6vw;

      .button {
        width: 9.37vw;
        height: @hr;
        border-radius: @hr;
        background: white;
        margin-left: 1.46vw;

        .label {
          font-size: 1.04vw;
          line-height: @hr;
          color: @color-primary;
        }

        .play {
          width: 1.11vw;
          height: auto;
          margin-left: 0.26vw;
        }

        &.primary {
          background: @color-primary;
          margin-left: 0;

          .label {
            color: white;
          }
        }
      }
    }
  }

  .introduction-video {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);

    .video-wrapper {
      width: 80vw;
      height: 45vw;
      background-color: white;
      border-radius: 0.6vw;
      overflow: hidden;
    }
  }
}
</style>